import { IAlertProps } from '@/pages/Alert/alerts.interface';

export const ALERT_STEPPER_LABELS: any = {
  sandstar: { label: 'Sandstar' },
  vdi: { label: 'VDI' },
  seed: { label: 'SEED' },
  sen: { label: 'SEN' },
};

// Enums
export enum RetryLabels {
  PROCESSED_RETRIES = 'Processed Retries',
  PATCH_RETRIES = 'Patch Retries',
  CREATE_SYNC_5XX_RETRIES = 'Create Sync 5XX Retries',
  GET_SYNC_5XX_RETRIES = 'Get Sync 5XX Retries',
  UPDATE_SYNC_5XX_RETRIES = 'Update Sync 5XX Retries',
}

export enum CardTitles {
  CLIENT = 'Client',
  PARTNER = 'Partner',
}

export enum AlertLabels {
  ALERT = 'Alert',
  LEVEL = 'Level',
  ALERT_STATUS = 'Alert Status',
}

export enum SectionTitles {
  ACTIVITY_TIMELINE = 'Activity Timeline',
  CLIENT_PARTNER_STATUS = 'Client & Partner Status',
  CLIENT_SUMMARY = 'Client Summary',
  PARTNER_SUMMARY = 'Partner Summary',
}

export enum NoDataMessages {
  NO_ACTIVITY_LOG_STEPPER = 'No Activity Log Data for Stepper Flow',
  NO_ACTIVITY_LOG_RECEIVED = 'No Activity Log Data Received',
  NO_CLIENT_PARTNER_RECEIVED = 'No Client/Partner Status Data Received',
  NO_PARTNER_OR_CLIENT_AVAILABLE = 'No Partner or Client data available',
  N_A = 'N/A',
  N_A_DATE = 'N/A Date',
}

export enum StatusIconType {
  SUCCESS = 'success',
  FAIL = 'fail',
  LOADER = 'loader',
  HYPHEN = 'hyphen',
}

export enum EALERT_LIFECYCLE {
  HUB = 'HUB',
  FULL = 'FULL',
}
